import "tailwindcss/dist/base.css"

import "prismjs/themes/prism-solarizedlight.css"